import {GeneratorValues} from "../../../product-types";
import {Font} from "three/examples/jsm/loaders/FontLoader";
import {TextGeometry} from "three/examples/jsm/geometries/TextGeometry";
import font from '../../../../../providers/fonts/helvetiker_regular.typeface.json';
import * as THREE from "three";
import {createBase} from "./base";
import {wallThickness} from "../../../../consts";
import {ExtrudeGeometry} from "three";
import { mergeGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils.js';

export const createText = (radius: number, values: GeneratorValues) => {
    const base = createBase(radius, values);
    const f: Font = new Font(font);
    const text = `${values.text}` || 'TEXT';

    const circleShape = new THREE.Shape();
    circleShape.absarc(0, 0, radius, 0, Math.PI * 2, false);

    const fontSize = values.height * 0.50;
    const fontMargin = values.height * 0.75;

    const textGeometry = new TextGeometry(text, {
        font: f,
        size: fontSize,
        height: wallThickness,
        curveSegments: 32,
        // bevelEnabled: true, // Enable beveling for thicker appearance
        // bevelThickness: 1, // How deep the bevel goes
        // bevelSize: 1.5, // Outward extension of the bevel
        // bevelSegments: 5, // Smoother bevel with more segments
    });
    textGeometry.rotateX(-2 * (180/Math.PI))

    const extrusionDepth = wallThickness * 3; // Increased thickness

    const positions = textGeometry.attributes.position

    for (let i = 0; i < positions.count; i++) {
        // Calculate the twist factor based on the y position of the vertex
        const vertex = new THREE.Vector3()
        vertex.fromBufferAttribute(positions, i)

        const textRadius = radius + 1;

        const angle = vertex.x / textRadius;

        const newX = Math.sin(angle) * textRadius;
        const newZ = Math.cos(angle) * textRadius; // Position at surface
        // const scalar = Math.PI * vertex.x * vertex.x;

        // const distance = new THREE.Vector2(vertex.x, vertex.y)
        // const newDistance = distance.multiplyScalar(1 + scalar / distance.length())

        positions.setXYZ(i, newX, newZ, vertex.z + fontMargin)
    }


    const mergedGeometry = mergeGeometries([base, textGeometry]);
    return mergedGeometry as unknown as ExtrudeGeometry;
}